import { transformActualImplementationToTableData } from './transformActualImplementationToTableData';

export { transformActualImplementationToTableData };
